/**
 * Enum representing all the possible time periods available for the bot stats
 */
export enum TimePeriod {
  Day = 24 * 3600,
  Week = 7 * (24 * 3600),
  Month = 30 * (24 * 3600),
  ThreeMonths = 90 * (24 * 3600),
  SixMonths = 180 * (24 * 3600),
  FromStart = -1,
}

/**
 * 🔨 Converts a string to TimePeriod object
 */
export function toTimePeriod(timePeriodAsString?: any): number {
  switch (timePeriodAsString) {
    case "day": return TimePeriod.Day;
    case "week": return TimePeriod.Week;
    case "month": return TimePeriod.Month;
    case "threeMonths": return TimePeriod.ThreeMonths;
    case "sixMonths": return TimePeriod.SixMonths;
    case "fromStart": return TimePeriod.FromStart;
    default: return TimePeriod.Month;
  }
}

/**
 * 🔨 Converts a TimePeriod object to a string
 */
export function toTimePeriodString(timePeriod: TimePeriod | null) {
  switch (timePeriod) {
    case TimePeriod.Day: return "day";
    case TimePeriod.Week: return "week";
    case TimePeriod.Month: return "month";
    case TimePeriod.ThreeMonths: return "threeMonths";
    case TimePeriod.SixMonths: return "sixMonths";
    case TimePeriod.FromStart: return "fromStart";
    default: return "month";
  }
}